import { render, staticRenderFns } from "./ZCCitySolar.vue?vue&type=template&id=6154dd88&scoped=true&"
import script from "./ZCCitySolar.vue?vue&type=script&lang=ts&"
export * from "./ZCCitySolar.vue?vue&type=script&lang=ts&"
import style0 from "./ZCCitySolar.vue?vue&type=style&index=0&id=6154dd88&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6154dd88",
  null
  
)

export default component.exports